<script lang="ts" setup>
    const props = defineProps<{
        title: string;
        description?: string;
    }>();
</script>
<template>
  <div class="container-fluid title-block-section">
    <div class="container-xl title-block-div d-flex align-items-center justify-content-center flex-column">
      <h1 class="mb-4" v-html="props?.title"></h1>
      <div v-if="props?.description" class="description text-center" v-html="props?.description"></div>
    </div>
  </div>
</template>